import { render, staticRenderFns } from "./ApplicationView.vue?vue&type=template&id=51526ddc&scoped=true&"
import script from "./ApplicationView.vue?vue&type=script&lang=js&"
export * from "./ApplicationView.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationView.vue?vue&type=style&index=0&id=51526ddc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51526ddc",
  null
  
)

export default component.exports